import Address from './Address.js';
import AiChat from './AiChat.js';
import AiImage from './AiImage.js';
import AiText from './AiText.js';
import CDN from './CDN.js';
import Change from './Change.js';
import ChartAlt from './ChartAlt.js';
import Chat from './Chat.js';
import Checkmark from './Checkmark.js';
import CircleCheckmark from './CircleCheckmark.js';
import CircleMinus from './CircleMinus.js';
import Close from './Close.js';
import Compliance from './Compliance.js';
import Copy from './Copy.js';
import DayNight from './DayNight.js';
import Delete from './Delete.js';
import Design from './Design.js';
import Development from './Development.js';
import DollarSign from './DollarSign.js';
import Download from './Download.js';
import Drag from './Drag.js';
import Duplicate from './Duplicate.js';
import ExternalLink from './ExternalLink.js';
import Filter from './Filter.js';
import Font from './Font.js';
import GenerateKeywords from './GenerateKeywords.js';
import Globe from './Globe.js';
import Groups from './Groups.js';
import Growth from './Growth.js';
import HeartPulse from './HeartPulse.js';
import Import from './Import.js';
import List from './List.js';
import Logout from './Logout.js';
import Mail from './Mail.js';
import Merge from './Merge.js';
import Minus from './Minus.js';
import MobileDevices from './MobileDevices.js';
import Paperclip from './Paperclip.js';
import Past from './Past.js';
import Phone from './Phone.js';
import Plus from './Plus.js';
import PreviewCrossed from './PreviewCrossed.js';
import Radio from './Radio.js';
import Reload from './Reload.js';
import Retransmit from './Retransmit.js';
import RowAdd from './RowAdd.js';
import RowRemove from './RowRemove.js';
import Rows from './Rows.js';
import RSS from './RSS.js';
import Running from './Running.js';
import Save from './Save.js';
import Search from './Search.js';
import SidebarToggle from './SidebarToggle.js';
import SortingOff from './SortingOff.js';
import Spinner from './Spinner.js';
import Translate from './Translate.js';
import Upload from './Upload.js';
export const DefaultIcons = {
    Address,
    AiChat,
    AiImage,
    AiText,
    CDN,
    Change,
    ChartAlt,
    Chat,
    Checkmark,
    CircleCheckmark,
    CircleMinus,
    Close,
    Compliance,
    Copy,
    DayNight,
    Delete,
    Design,
    Development,
    DollarSign,
    Download,
    Drag,
    Duplicate,
    ExternalLink,
    Filter,
    Font,
    GenerateKeywords,
    Globe,
    Groups,
    HeartPulse,
    Import,
    List,
    Logout,
    Mail,
    Merge,
    Minus,
    MobileDevices,
    Paperclip,
    Past,
    Phone,
    Plus,
    PreviewCrossed,
    Radio,
    Reload,
    Retransmit,
    RowAdd,
    RowRemove,
    Rows,
    RSS,
    Running,
    Save,
    Search,
    SidebarToggle,
    SortingOff,
    Spinner,
    Translate,
    Growth,
    Upload,
};
export default DefaultIcons;
